export default __webpack_public_path__ + "static/media/Img0012.c34e907a.png";